module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fma1"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('i', [_vm._v("PROLOGUE")])])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/sta.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fma"
  }, [_c('b', [_vm._v("Friday, June 17, 2016")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For a brief moment, Kevin did not know where he was. An eerie predawn silence blanketed the summer air. It was four o’clock in the morning. The birds were still quiet; the dawn chorus had not yet begun. Elias, his dog, begrudgingly stirred when Kevin sat up in bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kevin felt his way through the unfamiliar house, trying to be as quiet as possible so he wouldn’t wake his friend. He made his way up the flight of stairs and out onto the back deck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The house was perched on a cliff overlooking a lake. Kevin wanted to enjoy the rising sun—to experience the warmth as it touched his upturned face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The air smelled fresh—if a bit too sweet from the abundance of floral scents competing for his attention. Nevertheless, it was a welcome relief from the cloying, and often putrid, summer air in the city. He could hear waves gently lapping against the boat dock below and the first faint, distant quacks of ducks. Kevin found a deck chair and lowered himself into it. Elias settled down next to him.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("As dawn approached, Kevin searched for the warmest spot on the horizon; he knew that was where the sun would peek up first. Something ")]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_vm._v("above caught his attention, distracting his gaze. He raised his head and forced his eyes upward.")])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Kevin began to cry, although he had no idea why.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At first, he thought the faint lights in the sky were something teasing his optic nerve. He wasn’t sure if he was hallucinating or merely remembering what the night sky looked like right before daybreak. Suddenly, Kevin’s brain caught up with his emotions. As he steadied his eyes, he could see the reason for his unexplained tears—the hazy outline of tiny stars twinkling in the fading darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kevin hurried inside, stumbled back down the stairs to his room, and picked up his journal. He wanted to make the latest entry while the emotional sensation was still fresh in his memory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("I am seated in a wicker rocker facing Lake Mahopac. The delicious stillness is suddenly interrupted by spasms of joy-filled tears. After a momentary lapse, it becomes evident why I am crying. For the first time in nineteen years. I am seeing a star-filled sky")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76ff777c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Fm04.vue
// module id = 90
// module chunks = 0